/* eslint-disable */

var API = require('./api');

var ProductAvailability = require('./productavailability');
var ProductAvailabilityType = require('./productavailabilitytype');
var StoreAvailability = require('./storeavailability').StoreAvailability;


/** @constructor */
/** @param {string} productId */
function Product(productId){
    this.__productId = productId;
}
Product.prototype = {
    __productId : null,

    /** @returns {string} */
    getIdentifier : function(){
        return this.__productId || "";
    },

    /** @param {string} location */
    /** @param {function(data : ProductAvailability)} onsuccess */
    /** @param {function(error : string)} onerror */
    getAvailability : function(location, onsuccess, onerror){
        API.getProductAvailability(this, location, onsuccess, onerror);
    }
}


module.exports = Product;
